import { useGLTF } from '@react-three/drei'
export default function Model(props) {
  const { nodes, materials } = useGLTF('/Model4.glb')
  return (
    <group {...props} dispose={null} position={[0, -1.5, 3.5]} rotation={[0, 4.71, 0]}>
      <group name="Ecran_6" position={[0.121, 0.007, 0]}>
        <mesh
          name="Object_6"
          geometry={nodes.Object_6.geometry}
          material={materials.MacBookPro}
        />
        <mesh
          name="Object_8"
          geometry={nodes.Object_8.geometry}
          material={materials.MacBookPro}
        />
      </group>
      <mesh
        name="Object_4"
        geometry={nodes.Object_4.geometry}
        material={materials.MacBookPro}
      />
      <mesh
        name="img"
        geometry={nodes.img.geometry}
        material={materials.img}
        position={[0.124, 0.134, 0]}
        rotation={[Math.PI / 2, 0, Math.PI / 2]}
        scale={[0.18, 0.1, 0.207]}
      />
    </group>
  )
}
useGLTF.preload('/Model4.glb')